<div class="preloaderInputField">
    <div class="fountainG-outer-wrap">
        <div class="fountainG-inner-wrap">
            <div id="fountainG_1" class="fountainG"></div>
            <div id="fountainG_2" class="fountainG"></div>
            <div id="fountainG_3" class="fountainG"></div>
        </div>
    </div>
</div>